import * as React from 'react';
import { OnlineReservationInListDTO, Res } from 'core/api';

import { startOfDay } from 'date-fns';
import * as SalesStore from '../SalesStore';
import { ActionButtonDefinition, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import { Result, SessionProvider } from 'core/infrastructure';
import * as Images from 'pos/Images';
import { ReservationList } from './ReservationList';
import getAvailableReservations from './getAvailableReservations';
import { Command } from 'pos/common';
import { Message, Modal } from 'core/ui-next/modal';
import { Toaster } from 'core/ui-next';

type Props = {
	reservations: OnlineReservationInListDTO[];
} & Modal.Actions<OnlineReservationInListDTO>;


type State = {
	selected: Nullable<OnlineReservationInListDTO>;
};


class SelectReservationScreen extends PosScreenClassComponent<Props, State> {

	createInitialState(_props: Props): Nullable<State> {
		return {
			selected: null
		};
	}

	onComponentDidMount(): void { }
	onComponentWillUnmount(): void { }

	protected getScreenId(): string {
		return 'ASSIGN_RESERVATION';
	}

	protected getTitle(): string {
		return Res.Web.SELECT_ONLINE_RESERVATION();
	}

	protected getImage(): string | SvgIcon {
		return Images.OnlineReservation;
	}

	protected useKeypad() {
		return false;
	}

	protected getSize(): ScreenSize {
		return 'medium';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {

		// No me acaba de convencer que "Continuar sin reservas" sea un cancel, porque parece que
		// ha fallado la pantalla en lugar de que se ha elegido no poner reserva, pero queda más
		// o menos encapsulado en la funcion de assignReservation

		const onAssignReservation = async () => {

			if (this.state.selected === null) {
				Toaster.error(Res.Msg.MSG_NOT_SELECTED_RESERVATION());
				return;
			}

			this.close(this.state.selected);
		};

		return [
			{ title: Res.Web.SELECT_ONLINE_RESERVATION_CONTINUE_WITH_RESERVATION_BTN(), image: Images.Ok, action: onAssignReservation },
			null,
			null,
			null,
			null,
			{ title: Res.Web.SELECT_ONLINE_RESERVATION_CONTINUE_WITHOUT_RESERVATION_BTN(), image: Images.Next, action: (async () => this.cancel()) }
		];
	}

	protected getContent(): React.ReactNode {

		const onSelectReservation = (reservation: OnlineReservationInListDTO) => this.setState({ selected: reservation });

		return <ReservationList
			headerText={Res.Web.SELECT_ONLINE_RESERVATION_DATE_RESERVATIONS_LBL()}
			items={this.props.reservations}
			selected={this.state.selected}
			onItemSelected={reservation => onSelectReservation(reservation)}
		/>;
	}
}

async function setReservation(reservation: OnlineReservationInListDTO): Promise<Result> {
	const reservationResult = await SalesStore.setReservation(reservation);
	if (!reservationResult.ok) {
		await Message.show(reservationResult.error.message);
		return Result.error();
	}

	return Result.ok();
}

declare global {
	interface CommandType {
		assignReservation: (reservation: Nullable<OnlineReservationInListDTO>) => Promise<Result>
	}
}

Command.register('assignReservation', 'NO_PRECONDITION', async (reservation: Nullable<OnlineReservationInListDTO>): Promise<Result> => {

	if (!SessionProvider.isOnlineReservationModuleEnabled())
		return Result.ok();

	if (reservation !== null) {
		return await setReservation(reservation);
	}

	const location = SalesStore.getTicket().Location;
	const today = startOfDay(new Date());

	const reservations = await getAvailableReservations(today, location.SaleLocationName);
	if (reservations.length) {
		const result = await Modal.show(SelectReservationScreen, { reservations });
		if (result.ok)
			return await setReservation(result.value);
	}

	return Result.ok();
});
